import { toast } from 'vue-sonner';

/**
 * `$toast` on top of the UI kit's Toaster (vue-sonner), keeping the API the
 * app used with vue-toast-notification: success / error / info(message) and
 * clear(). Messages are rendered as plain text.
 */
/* eslint-disable-next-line local-rules/custom-naming-pattern */
const ToastPlugin = {
  install(app) {
    app.config.globalProperties.$toast = {
      success: message => toast.success(message),
      error: message => toast.error(message),
      info: message => toast.info(message),
      clear: () => toast.dismiss(),
    };
  },
};

export default ToastPlugin;
